import React from "react";
import { useTranslation } from "react-i18next";

export const SelectPlanSidebarStepContent: React.FC = () => {
    const { t } = useTranslation("getting-started");

    return <p>{t("select-plan.sidebar-content")}</p>;
};
